import type { FC } from "react"
import { Outlet, useLocation } from "react-router"
import { getTenantSignupFlow } from "@/components/tenant/tenant-signup-flow"
import { TenantSignupShell } from "@/components/tenant/tenant-signup-shell"

export const SignupLayout: FC = () => {
  const location = useLocation()
  const currentStep =
    location.pathname === "/signup/info"
      ? "shop-info"
      : location.pathname === "/signup/email-not-verified"
        ? "verification"
        : "account"
  const { title, steps } = getTenantSignupFlow(currentStep, {
    accountTitle: "店舗アカウント登録",
    verificationTitle: "メール認証",
    shopInfoTitle: "店舗情報登録",
  })

  return (
    <div className="mx-auto w-full max-w-[832px]">
      <TenantSignupShell title={title} steps={steps}>
        <Outlet />
      </TenantSignupShell>
    </div>
  )
}
